<google-map
  width="100%"
  height="100%"
  [options]="mapOptions"
  [mapTypeId]="mapTypeIds[chosenMapTypeId]"
  (mapInitialized)="mapReady($event)"
  (mapClick)="onMapClick($event)"
  >
  <!-- own position -->
  <map-marker *ngIf="ownPositionMarker"
    [options]="{
      clickable: false,
      icon: ownPositionMarker.icon,
      zIndex: 999999
    }"
    [position]="{lat: ownPositionMarker.latitude, lng: ownPositionMarker.longitude}">
  </map-marker>

  <!-- Locations -->
  <div *ngIf="showLocations">
    <div *ngFor="let l of locationsList">
      <map-polygon
        [options]="{
          clickable: false,
          fillColor: l.color,
          fillOpacity: 0.3,
          strokeColor: l.color,
          strokeOpacity: 1.0
        }"
        [paths]="l.boundaryMarkerPath">
      </map-polygon>

      <map-marker
        [options]="{
          clickable: false,
          icon: l.icon
        }"
        [position]="{lat: l.location.geometry.centroid.latitude, lng: l.location.geometry.centroid.longitude}">
      </map-marker>

    </div>
  </div>

  <!-- Fields -->
  <div *ngIf="showFields">
    <div *ngFor="let f of fieldsList">
      <map-polygon
        [options]="{
          clickable: false,
          fillColor: f.color,
          fillOpacity: 0.3,
          strokeColor: f.color,
          strokeOpacity: 1.0
        }"
        [paths]="f.boundaryMarkerPath">
      </map-polygon>

      <map-marker *ngIf="defaultZoom"
        [options]="{
          clickable: false,
          icon: f.icon
        }"
        [position]="{lat: f.field.geometry.centroid.latitude, lng: f.field.geometry.centroid.longitude}">
      </map-marker>

      @if (f.field.geometry.pois) {
        <map-marker *ngIf="defaultZoom"
          [options]="{
            clickable: false,
            icon: entranceIcon,

          }"
          [position]="{lat: f.field.geometry.pois[0]?.coordinate.latitude, lng: f.field.geometry.pois[0]?.coordinate.longitude}">
        </map-marker>
      }

    </div>
  </div>

</google-map>

<ion-fab vertical="top" horizontal="end" slot="fixed">
  <ion-row>
    <ion-fab-button size="small" (click)="onCenterOnOwnPositionClick()">
      <ion-icon name="locate-outline"></ion-icon>
    </ion-fab-button>
    <ion-fab-button size="small" (click)="onChangeMapType()">
      <ion-icon name="map-outline"></ion-icon>
    </ion-fab-button>
  </ion-row>
</ion-fab>

<!-- 2nd row: geolocation edit -->
<div *ngIf="drawModeActive">
  <ion-fab vertical="bottom" horizontal="start">
    <!-- RESET -->
    <ion-fab-button (click)="onReset()" size="small">
      <ion-icon name="close-outline"></ion-icon>
    </ion-fab-button>
  </ion-fab>

    <!-- UNDO -->
     @if (addMode) {
       <ion-fab vertical="bottom" horizontal="center">
         <ion-fab-button (click)="undoAction()" size="small">
           <ion-icon name="return-up-back-outline"></ion-icon>
         </ion-fab-button>
       </ion-fab>
     }

  <!-- NEXT -->
  <ion-fab vertical="bottom" horizontal="end">
    <ion-fab-button (click)="onSubmitDrawing()" size="small">
      <ion-icon name="arrow-forward-outline"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</div>
